import { Pipe, PipeTransform } from '@angular/core';
import { filter, propEq } from 'ramda/es';
@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value, args: string[]): any {
    return Object.keys(value).map(key => ({
      key,
      value: value[key]
    }));
  }
}

@Pipe({ name: 'premium' })
export class PremiumPipe implements PipeTransform {
  transform(plugins, isPremium: boolean): any {
    if (isPremium) {
      return filter(propEq('isActivated', true))(plugins);
    }
    return plugins;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/plugins/list/plugin-filter.pipe.ts